import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './Component_CalculationSimulator.scss';
import { BadImplementationException, capitalizeFirstLetter, generateUUID } from '@nu-art/ts-common';
import { ModuleFE_Value } from '../../../../../../../_entity/value/index.js';
import { DropDown_Values } from '../../../../../../shared-components/index.js';
import { ModuleFE_Expression } from '../../../../../../../_entity/expression/index.js';
import { ModuleFE_Variable } from '../../../../../../../_entity/variable/index.js';
import { ExpressionType_GeneralFunction, labsExpressionTitles, valueID_No, valueID_Yes, valueID_YesNo } from '@app/hcs-shared';
import { getGrammarUtils } from './utils.js';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Component_CalculationSimulator extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.variableList = this.extractEntitiesFromExpression(this.props.editable.item.expression);
        return state;
    }
    extractEntitiesFromExpression(expression) {
        if (!expression || !expression.length)
            return [];
        const regex = /(var|attr|precipitating|relieving|expr)\(([^)]*?)\)/g;
        let match;
        const results = [];
        while ((match = regex.exec(expression)) !== null) {
            const prevValue = this.state?.variableList?.findIndex(item => item.ids === match[2]);
            if (results.findIndex(item => item.ids === match[2]) === -1)
                results.push({
                    type: match[1],
                    ids: match[2],
                    fullExpression: match[0],
                    value: this.state?.variableList?.[prevValue]?.value
                });
        }
        return results;
    }
    calculateExpression = () => {
        if (!this.state.variableList.length)
            return;
        let _expr = this.state.currLab ?? this.state.expression;
        _expr = this.replaceVarsWithValues(_expr);
        const grammarUtils = getGrammarUtils(_expr);
        const currResult = grammarUtils.resolver.visit(grammarUtils.parser.expression());
        this.setState({ currResult: currResult.toString() });
    };
    replaceVarsWithValues(_expr) {
        return this.state.variableList.reduce((expression, currItem) => {
            if (currItem.value) {
                const enumValue = ModuleFE_Value.cache.unique(currItem.value);
                const escapedExpression = currItem.fullExpression.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedExpression, 'g');
                if (enumValue) {
                    expression = expression.replace(regex, `"${enumValue.data.value}"`);
                }
                else {
                    expression = expression.replace(regex, currItem.value);
                }
            }
            return expression;
        }, _expr);
    }
    renderDDValues = (variable, index) => {
        return _jsx(DropDown_Values, { variable: variable, selected: this.state.variableList[index].value, onSelected: (value) => {
                this.state.variableList[index].value = value._id;
                this.forceUpdate();
            } });
    };
    renderDDYesNo = (index) => {
        return _jsx(DropDown_Values, { selected: this.state.variableList[index].value, onSelected: (value) => {
                this.state.variableList[index].value = value._id;
                this.forceUpdate();
            }, variable: { valueId: valueID_YesNo }, queryFilter: (val) => {
                return val._id === valueID_Yes || val._id === valueID_No;
            } });
    };
    renderNumericInput = (index) => {
        return _jsx(TS_Input, { type: 'number', placeholder: 'Insert Value', value: this.state.variableList[index].value, onBlur: (value) => {
                this.state.variableList[index].value = value;
                this.forceUpdate();
            } });
    };
    renderInputType = (index, variable, expression) => {
        if (variable)
            return this.renderInputByVarType(variable, index);
        return this.renderInputByExpressionType(expression, index);
    };
    renderInputByExpressionType = (expression, index) => {
        switch (expression.expressionType) {
            case ExpressionType_GeneralFunction.dbKey:
                return this.renderDDYesNo(index);
            default:
                return this.renderNumericInput(index);
        }
    };
    renderInputByVarType = (variable, index) => {
        const dbValue = ModuleFE_Value.cache.unique(variable.valueId);
        if (!dbValue)
            throw new BadImplementationException(`value with id ${variable.valueId} not found`);
        switch (dbValue.type) {
            case 'enumerated':
                return this.renderDDValues(variable, index);
            case 'tuple':
                return this.renderDDValues(variable, index);
            default:
                return this.renderNumericInput(index);
        }
    };
    renderExpression = (item, index) => {
        const expression = ModuleFE_Expression.cache.unique(item.ids);
        if (!expression)
            return '';
        return _jsx(TS_PropRenderer.Horizontal, { label: capitalizeFirstLetter(expression.label), children: this.renderInputType(index, undefined, expression) }, generateUUID());
    };
    renderVariable = (item, index) => {
        const variable = ModuleFE_Variable.cache.unique(item.ids);
        if (!variable)
            return '';
        return _jsx(TS_PropRenderer.Horizontal, { label: capitalizeFirstLetter(variable.name), children: this.renderInputType(index, variable) }, generateUUID());
    };
    renderAttribute = (item, index) => {
        const ids = item.ids.split(',');
        const variable = ModuleFE_Variable.cache.unique(ids[0]);
        const attribute = ModuleFE_Variable.cache.unique(ids[1]);
        if (!variable || !attribute)
            return '';
        return _jsx(TS_PropRenderer.Horizontal, { label: `${capitalizeFirstLetter(variable.name)}.${capitalizeFirstLetter(attribute.name)}`, children: this.renderInputType(index, attribute) }, generateUUID());
    };
    renderFactor = (item, index) => {
        const ids = item.ids.split(',');
        const variable = ModuleFE_Variable.cache.unique(ids[0]);
        const attribute = ModuleFE_Variable.cache.find(_var => _var._nameInLowercase.includes(item.type));
        const factor = ModuleFE_Variable.cache.unique(ids[1]);
        if (!variable || !attribute || !factor)
            return '';
        return _jsx(TS_PropRenderer.Horizontal, { label: `${capitalizeFirstLetter(variable.name)}.${capitalizeFirstLetter(attribute.name)}.${capitalizeFirstLetter(factor.name)}`, children: this.renderInputType(index, factor) }, generateUUID());
    };
    renderList = () => {
        if (!this.state.variableList.length)
            return _jsx("div", { className: 'variable-list simulator-title', children: "No Variables Found..." });
        return _jsx(LL_V_L, { className: 'variable-list', children: this.state.variableList.map((item, index) => {
                switch (item.type) {
                    case 'var':
                        return this.renderVariable(item, index);
                    case 'attr':
                        return this.renderAttribute(item, index);
                    case 'expr':
                        return this.renderExpression(item, index);
                    default:
                        return this.renderFactor(item, index);
                }
            }) });
    };
    renderCalculateExprContainer = () => {
        const className = _className('calculate-btn', !this.state.variableList.length && 'disabled');
        return _jsxs(LL_H_C, { className: 'calculation-container', children: [_jsx(Button, { variant: 'primary', className: className, onClick: this.calculateExpression, children: "Calculate" }), _jsx("div", { children: this.state.currResult ? `Result: ${this.state.currResult}` : '' })] });
    };
    renderLabRangesDropdown = () => {
        const adapter = SimpleListAdapter(labsExpressionTitles, item => _jsx("div", { children: item.item }));
        return _jsx("div", { className: 'labs-dropdown', children: _jsx(TS_DropDown, { className: 'match_width', adapter: adapter, onSelected: this.setSelectedLabType, selected: this.state.selectedLabExpression }) });
    };
    setSelectedLabType = (val) => {
        const index = labsExpressionTitles.indexOf(val);
        const currLab = this.state.expression.split(',')[index];
        const varList = this.extractEntitiesFromExpression(currLab);
        this.setState({ currLab: currLab, variableList: varList, selectedLabExpression: val });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'calculator', children: [_jsx("div", { className: 'simulator-title', children: this.props.editable.item.label ?? 'Simulate Calculation' }), this.renderLabRangesDropdown(), this.renderList(), this.renderCalculateExprContainer()] });
    }
}
//# sourceMappingURL=Component_CalculationSimulator.js.map